import React, { Component } from 'react';
import AlarmSoundComponent from '../components/alarmSoundComponent';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {updateAlarmSound,getAlarmSound,updateCompressionAudio,updateAbortAudio, UpdateEditAudio,
    UpdateNormalSound, UpdateEmergencySound } from '../action/alarmSoundAction';

export class AlarmSoundContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAlarmSound(); 
    }
    getAllSoundData = () =>{
        this.props.actions.getAlarmSound(
            this.props.dispatch
        )
    }
    updateAlarmSoundFile = (formData) =>{
        this.props.actions.updateAlarmSound(
            formData,
            this.props.dispatch
        )
    }
    updateCompression = (formData) =>{
        this.props.actions.updateCompressionAudio(
            formData,
            this.props.dispatch
        )
    }
    updateAbortSound = (formData) =>{
        this.props.actions.updateAbortAudio(
            formData,
            this.props.dispatch
        )
    }
    updateSound = (formData) => {
        this.props.actions.UpdateEditAudio(
            formData,
            this.props.dispatch
        )
    }
    updateNormalSound = (formData) => {
        this.props.actions.UpdateNormalSound(
            formData,
            this.props.dispatch
        )
    }
    updateEmergencySound = (formData) => {
        this.props.actions.UpdateEmergencySound(
            formData,
            this.props.dispatch
        )
    }
    render(){
        return(
            <AlarmSoundComponent
                updateAlarmSound = {this.updateAlarmSoundFile}
                alarmSoundData = {this.props.alarmSoundData}
                updateCompressionSound = {this.updateCompression}
                updateAbortSound = {this.updateAbortSound}
                updateSound = {this.updateSound}
                updateNormalSound = {this.updateNormalSound}
                updateEmergencySound = {this.updateEmergencySound}
                getAllSoundData = {this.getAllSoundData}
            >
            </AlarmSoundComponent>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            updateAlarmSound,
            getAlarmSound,
            updateCompressionAudio,
            updateAbortAudio,
            UpdateEditAudio,
            UpdateNormalSound,
            UpdateEmergencySound
        },
            dispatch)
    };
}
function mapStateToProps({AlarmSoundReducer}) {
    console.log(AlarmSoundReducer);
    return {
        alarmSoundData : {
            errorCode : AlarmSoundReducer.errorCode,
            statusCode : AlarmSoundReducer.statusCode,
            alarmSoundList : AlarmSoundReducer.alarmSoundList,
            message: AlarmSoundReducer.message,
            updatedValue : AlarmSoundReducer.updatedValue,
            isLoading : AlarmSoundReducer.isLoading
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlarmSoundContainer));